/* =============================================
   Garaia Shop Bar — mobile filter / sort / view
   ============================================= */

(function () {
  'use strict';

  // Bumped to ':v2' to discard older saved "1-up" preferences so the
  // two-per-row default applies for everyone until they pick a view again.
  var STORAGE_KEY = 'garaia:shop:view:v2';

  function initStickyBehavior(root) {
    var stack = root.querySelector('.shop-page__bar-stack');
    if (!stack) return;
    if (typeof IntersectionObserver === 'undefined') return;

    /* Insert a sentinel just above the stack. When the sentinel
       scrolls off the top of the viewport, switch the bar to
       fixed-positioned so it pins at the top regardless of any
       sticky-positioning gotchas in the surrounding layout. */
    var sentinel = root.querySelector('.shop-page__bar-sentinel');
    if (!sentinel) {
      sentinel = document.createElement('div');
      sentinel.className = 'shop-page__bar-sentinel';
      stack.parentNode.insertBefore(sentinel, stack);
    }

    function applyStuckHeight() {
      /* Reserve the bar's height in flow while it's fixed. */
      var h = stack.offsetHeight;
      if (h > 0) {
        root.style.setProperty('--shop-bar-stuck-height', h + 'px');
      }
    }

    /* Re-measure if the viewport is resized (e.g., user opens devtools
       or rotates the device). */
    window.addEventListener('resize', applyStuckHeight);
    applyStuckHeight();

    /* Pin ONLY when the sentinel has scrolled above the viewport
       (top edge < 0). Plain !entry.isIntersecting also fires when
       the sentinel is BELOW the viewport (page taller than the
       viewport at load), which would incorrectly pin the bar
       before the shopper has scrolled. Checking boundingClientRect.top
       distinguishes "scrolled past" from "not yet visible". */
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stack.classList.toggle('is-stuck', entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    observer.observe(sentinel);
  }

  function init(root) {
    initStickyBehavior(root);

    var bar = root.querySelector('.shop-page__bar');
    if (!bar) return;
    var grid = root.querySelector('.shop-page__grid');
    if (!grid) return;

    var filterCell = bar.querySelector('[data-toggle="filter"]');
    var sortCell = bar.querySelector('[data-toggle="sort"]');
    if (!filterCell || !sortCell) return;

    var filterPanel = root.querySelector('#' + filterCell.getAttribute('aria-controls'));
    var sortPanel = root.querySelector('#' + sortCell.getAttribute('aria-controls'));
    if (!filterPanel || !sortPanel) return;

    var viewBtns = bar.querySelectorAll('.shop-page__view-btn');

    function setExpanded(cell, val) {
      cell.setAttribute('aria-expanded', val ? 'true' : 'false');
    }

    function closeAll() {
      filterPanel.classList.remove('is-open');
      sortPanel.classList.remove('is-open');
      setExpanded(filterCell, false);
      setExpanded(sortCell, false);
    }

    function togglePair(cell, panel, otherCell, otherPanel) {
      var willOpen = !panel.classList.contains('is-open');
      otherPanel.classList.remove('is-open');
      setExpanded(otherCell, false);
      panel.classList.toggle('is-open', willOpen);
      setExpanded(cell, willOpen);
    }

    filterCell.addEventListener('click', function () {
      togglePair(filterCell, filterPanel, sortCell, sortPanel);
    });
    sortCell.addEventListener('click', function () {
      togglePair(sortCell, sortPanel, filterCell, filterPanel);
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) return;
      var inBar = bar.contains(e.target);
      var inFilter = filterPanel.contains(e.target);
      var inSort = sortPanel.contains(e.target);
      if (!inBar && !inFilter && !inSort) closeAll();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });

    function applyView(v) {
      if (v !== '1' && v !== '2') v = '2';
      grid.setAttribute('data-view', v);
      viewBtns.forEach(function (btn) {
        var match = btn.getAttribute('data-view') === v;
        btn.classList.toggle('is-on', match);
        btn.setAttribute('aria-pressed', match ? 'true' : 'false');
      });
    }

    var saved = null;
    try { saved = localStorage.getItem(STORAGE_KEY); } catch (_) { saved = null; }
    if (saved) applyView(saved);

    viewBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = btn.getAttribute('data-view');
        applyView(v);
        try { localStorage.setItem(STORAGE_KEY, v); } catch (_) {}
      });
    });
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    document.querySelectorAll('.shop-page').forEach(init);
  });
})();
